import React, { useState } from 'react'
import { Field, FormSection } from 'redux-form';
import { AutoCompleteSelect, Input, InputWithIcon } from '../../../../../../../../../itrust_common/components/form';

function SpecteraFramesBenefit(props) {
  const { portalType } = props
  const [loading, setLoading] = useState(false)

  const loader = loading && (
    <div className="form-group col-3 d-flex align-items-end pb-5">
      <div className="spinner-border spinner-border-sm text-primary" role="status" />
      <span className="ml-2 text-muted">Loading...</span>
    </div>
  )

  return (
    <div>
      <h5 className='mb-5'>Frames Benefit</h5>
      {portalType === 'lab' && (
        <>
          <FormSection name="lab_frame">
            <div className='row mt-6'>
              <Field
                name="manufacturer"
                label="Manufacturer"
                component={Input}
                className="form-control"
                wrapperClasses={`form-group col-4`}
              />
              <Field
                name="collection"
                label="Collection"
                component={Input}
                className="form-control"
                wrapperClasses={`form-group col-4`}
              />
              <Field
                name="style"
                label="Style"
                component={Input}
                className="form-control"
                wrapperClasses={`form-group col-4`}
              />
              <Field
                name="model"
                label="Model"
                component={Input}
                className="form-control"
                wrapperClasses={`form-group col-4`}
              />
              <Field
                name="color"
                label="Color"
                component={Input}
                className="form-control"
                wrapperClasses={`form-group col-4`}
              />
              <Field
                name="eye_size"
                valueField="value"
                textField="value"
                label="Eye Size"
                component={AutoCompleteSelect}
                data={[{ value: '25' }, { value: '26' }, { value: '27' }, { value: '28' }, { value: '29' }, { value: '30' }, { value: '31' }, { value: '32' }, { value: '33' }, { value: '34' }, { value: '35' }, { value: '36' }, { value: '37' }, { value: '38' }, { value: '39' }, { value: '40' }, { value: '41' }, { value: '42' }, { value: '43' }, { value: '44' }, { value: '45' }, { value: '46' }, { value: '47' }, { value: '48' }, { value: '49' }, { value: '50' }, { value: '51' }, { value: '52' }, { value: '53' }, { value: '54' }, { value: '55' }, { value: '56' }, { value: '57' }, { value: '58' }, { value: '59' }, { value: '60' }, { value: '61' }, { value: '62' }, { value: '63' }, { value: '64' }, { value: '65' }, { value: '66' }, { value: '67' }, { value: '68' }, { value: '69' }, { value: '70' }, { value: '71' }, { value: '72' }, { value: '73' }, { value: '74' }, { value: '75' }]}
                className="form-control"
                wrapperClasses={`form-group col-4`}
              />
              <Field
                name="b_measurement"
                label="B Measurement"
                valueField="value"
                textField="value"
                component={AutoCompleteSelect}
                data={[{ value: '10' }, { value: '11' }, { value: '12' }, { value: '13' }, { value: '14' }, { value: '15' }, { value: '16' }, { value: '17' }, { value: '18' }, { value: '19' }, { value: '20' }, { value: '21' }, { value: '22' }, { value: '23' }, { value: '24' }, { value: '25' }, { value: '26' }, { value: '27' }, { value: '28' }, { value: '29' }, { value: '30' }, { value: '31' }, { value: '32' }, { value: '33' }, { value: '34' }, { value: '35' }, { value: '36' }, { value: '37' }, { value: '38' }, { value: '39' }, { value: '40' }, { value: '41' }, { value: '42' }, { value: '43' }, { value: '44' }, { value: '45' }, { value: '46' }, { value: '47' }, { value: '48' }, { value: '49' }, { value: '50' }, { value: '51' }, { value: '52' }, { value: '53' }, { value: '54' }, { value: '55' }, { value: '56' }, { value: '57' }, { value: '58' }, { value: '59' }, { value: '60' }, { value: '61' }, { value: '62' }, { value: '63' }, { value: '64' }, { value: '65' }, { value: '66' }, { value: '67' }, { value: '68' }, { value: '69' }, { value: '70' }, { value: '71' }, { value: '72' }, { value: '73' }, { value: '74' }, { value: '75' }]}
                className="form-control"
                wrapperClasses={`form-group col-4`}
              />
              <Field
                name="bridge_size"
                label="Bridge Size"
                valueField="value"
                textField="value"
                component={AutoCompleteSelect}
                data={[{ value: '10' }, { value: '11' }, { value: '12' }, { value: '13' }, { value: '14' }, { value: '15' }, { value: '16' }, { value: '17' }, { value: '18' }, { value: '19' }, { value: '20' }, { value: '21' }, { value: '22' }, { value: '23' }, { value: '24' }, { value: '25' }]}
                className="form-control"
                wrapperClasses={`form-group col-4`}
              />
              <Field
                name="temple_size"
                label="Temple Size"
                valueField="value"
                textField="value"
                component={AutoCompleteSelect}
                data={[{ value: '100' }, { value: '101' }, { value: '102' }, { value: '103' }, { value: '104' }, { value: '105' }, { value: '106' }, { value: '107' }, { value: '108' }, { value: '109' }, { value: '110' }, { value: '111' }, { value: '112' }, { value: '113' }, { value: '114' }, { value: '115' }, { value: '116' }, { value: '117' }, { value: '118' }, { value: '119' }, { value: '120' }, { value: '121' }, { value: '122' }, { value: '123' }, { value: '124' }, { value: '125' }, { value: '126' }, { value: '127' }, { value: '128' }, { value: '129' }, { value: '130' }, { value: '131' }, { value: '132' }, { value: '133' }, { value: '134' }, { value: '135' }, { value: '136' }, { value: '137' }, { value: '138' }, { value: '139' }, { value: '140' }, { value: '141' }, { value: '142' }, { value: '143' }, { value: '144' }, { value: '145' }, { value: '146' }, { value: '147' }, { value: '148' }, { value: '149' }, { value: '150' }, { value: '151' }, { value: '152' }, { value: '153' }, { value: '154' }, { value: '155' }, { value: '156' }, { value: '157' }, { value: '158' }, { value: '159' }, { value: '160' }, { value: '161' }, { value: '162' }, { value: '163' }, { value: '164' }, { value: '165' }, { value: '166' }, { value: '167' }, { value: '168' }, { value: '169' }, { value: '170' }, { value: '171' }, { value: '172' }, { value: '173' }, { value: '174' }, { value: '175' }]}
                className="form-control"
                wrapperClasses={`form-group col-4`}
              />
              <Field
                name="edge_type"
                label="Edge Type"
                valueField="value"
                textField="value"
                component={AutoCompleteSelect}
                data={[{ value: 'Drill Mount' }, { value: 'Full - Metal' }, { value: 'Full- Zyl' }, { value: 'Grooved' }, { value: 'Industrial' }]}
                className="form-control"
                wrapperClasses={`form-group col-4`}
              />
              <Field name={`frame_bill_charges`} component={InputWithIcon} label="Frame Bill Charges" title="$" className="form-control" wrapperClasses="col-4 form-group" />
              {loader}
            </div>
          </FormSection>
          <FormSection name="spectera_lab">
            <div className='row mt-6'>
              <Field
                name="lab_name"
                valueField="STYLE"
                textField="STYLE"
                label="Lab Selection"
                data={[]}
                component={AutoCompleteSelect}
                wrapperClasses={`form-group col-4`}
              />
              {loader}
            </div>
          </FormSection>
        </>
      )}

      {portalType === 'nonlab' && (
        <FormSection name="frame">
          <div className='row mt-6'>
            <Field name={`frame_bill_charges`} component={InputWithIcon} label="Frame Bill Charges" title="$" className="form-control" wrapperClasses="col-4 form-group" />
            {loader}
          </div>
        </FormSection>
      )}
    </div>
  )
}

export default SpecteraFramesBenefit